import { Outlet } from "react-router-dom"

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"

import { AppHeader } from "@/app/layouts/AppHeader"
import { AppSidebar } from "@/app/layouts/AppSidebar"
import { AuthorFooter } from "@/app/layouts/AuthorFooter"
import { BreadcrumbProvider } from "@/app/layouts/breadcrumb"
import { useNotificacoesPush } from "@/hooks/useNotificacoesPush"

export function AppLayout() {
  useNotificacoesPush()

  return (
    <BreadcrumbProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <AppHeader />
          <div className="mx-auto w-full max-w-[1600px] flex-1 p-4 sm:px-6 lg:px-8 lg:py-7 2xl:px-10">
            <Outlet />
          </div>
          <footer className="border-t bg-muted/30">
            <div className="mx-auto w-full max-w-[1600px] px-4 py-2 sm:px-6 lg:px-8 2xl:px-10">
              <AuthorFooter />
            </div>
          </footer>
        </SidebarInset>
      </SidebarProvider>
    </BreadcrumbProvider>
  )
}
